import { FunctionComponent, useEffect } from "react";
import { Page } from "../Page";
import { useNavigate, useParams } from "react-router-dom";
import { UsersPanel } from "./UserPanel/UsersPanel";
import { ClientPanel } from "./ClientPanel/ClientPanel";
import { JurisdictionPanel } from "./JurisdictionPanel/JurisdictionsPanel";
import { useCurrentUser } from "../../api/users/userQueries";
import { Spinner, Flex } from "@chakra-ui/react";

export const SystemAdminPage: FunctionComponent = () => {
    const { tabId } = useParams();
    const navigate = useNavigate();
    const { data: currentUser, isLoading } = useCurrentUser();

    // Redirect non-admin users to unauthorized page
    useEffect(() => {
        if (!isLoading && currentUser && !currentUser.isSystemAdmin) {
            navigate("/unauthorized");
        }
    }, [currentUser, isLoading, navigate]);

    // Show loading spinner while checking user authentication
    if (isLoading) {
        return (
            <Flex justify="center" align="center" height="100vh">
                <Spinner size="xl" color="blue.500" />
            </Flex>
        );
    }

    // If user is not a system admin, don't render the page content
    // (the useEffect will handle the redirect)
    if (!currentUser?.isSystemAdmin) {
        return null;
    }

    const findCurrentTab = () => {
        if (!tabId) return 0; // Default to Clients tab if no tabId is provided
        switch (tabId) {
            case "user":
                return 1;
            case "client":
                return 0;
            case "jurisdictions":
                return 2;
            default:
                return 0; // Default to Clients tab for any unknown tabId
        }
    };

    return (
        <Page
            title="Admin"
            topNavProps={{
                showLogo: true,
                tabs: {
                    selectedIndex: findCurrentTab(),
                    tabs: [
                        {
                            name: "Clients",
                            onClick() {
                                navigate("/admin/client");
                            },
                        },
                        {
                            name: "Users",
                            onClick() {
                                navigate("/admin/user");
                            },
                        },
                        {
                            name: "Jurisdictions",
                            onClick() {
                                navigate("/admin/jurisdictions");
                            },
                        },
                    ],
                },
            }}
        >
            {tabId === "user" ? <UsersPanel /> : tabId === "client" ? <ClientPanel /> : tabId === "jurisdictions" ? <JurisdictionPanel /> : <ClientPanel />}
        </Page>
    );
};
